/**
 * Created by Ning Jiang on 3/20/2017.
 */


import {HarlequinServerDataParser} from "../HarlequinServerDataParser";
import {IHarlequinGameData, IHarlequinServerData} from "./IHarlequinServerData";
import {INudgeParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeParsedGameData";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";

export class HarlequinParsedGameData extends SpinParsedGameData implements INudgeParsedGameData {

    private readonly _doReelNudge:boolean[];
    private readonly _extraSymbolsOnTop:string[][];

    private readonly _wildOverlayReels:boolean [];
    private readonly _wildOverlayReelsBefore:boolean [];

    private readonly _wildMultipliers:number [];
    private readonly _wildMultipliersBefore:number [];

    private readonly _scattersFSCollectedAfter:number [];
    private readonly _scattersFSCollectedBefore:number;
    private readonly _scattersCollected:number;
    private readonly _scatterCollected:number;
    private readonly _extraScatterThisFSSpin:number [];

    private readonly _scattersCollectedFSAfter:number;
    private readonly _scattersCollectedFSBefore:number;

    private readonly _wildDrop:boolean [];
    private readonly _freespinPlayed:number;

    private readonly _totalSpinWinnings:string;

    private readonly _betLineWins:any [];

    private readonly _totalRespinWin:number;

    private readonly _extraSpinsAwardedThisSpin:number;
    private readonly _firstSpinWildDrop:boolean;

    public get scatterCollected():number {
        return this._scatterCollected;
    }

    public get firstSpinWildDrop():boolean {
        return this._firstSpinWildDrop;
    }

    public get totalRespinWin():number {
        return this._totalRespinWin;
    }

    public get betLineWins():IBetLineWinData [] {
        return this._betLineWins;
    }

    public get totalSpinWinnings():string {
        return this._totalSpinWinnings;
    }


    public get freespinPlayed():number {
        return this._freespinPlayed;
    }

    public get wildDrop():boolean [] {
        return this._wildDrop;
    }

    public get scattersCollected():number {
        return this._scattersCollected;
    }

    public get scattersFSCollectedAfter():number [] {
        return this._scattersFSCollectedAfter;
    }

    public get scattersFSCollectedBefore():number {
        return this._scattersFSCollectedBefore;
    }

    public get scattersCollectedFSAfter():number {
        return this._scattersCollectedFSAfter;
    }

    public get scattersCollectedFSBefore():number {
        return this._scattersCollectedFSBefore;
    }

    public get doReelNudge():boolean[] {
        return this._doReelNudge;
    }

    public get extraSymbolsOnTop():string[][] {
        return this._extraSymbolsOnTop;
    }

    public get wildOverlayReels():boolean [] {
        return this._wildOverlayReels;
    }

    public get wildOverlayReelsBefore():boolean [] {
        return this._wildOverlayReelsBefore;
    }

    public get wildMultipliers():number [] {
        return this._wildMultipliers;
    }

    public get wildMultipliersBefore():number [] {
        return this._wildMultipliersBefore;
    }

    public get extraScatterThisFSSpin():number [] {
        return this._extraScatterThisFSSpin;
    }

    public get extraSpinsAwardedThisSpin():number {
        return this._extraSpinsAwardedThisSpin;
    }

    protected isRespin(rawData:IHarlequinServerData):boolean {
        return (this.mode === "WILD_RESPIN" || this.mode === "WILD_RESPIN_FS");
    }

    protected isNextRespin(rawData:IHarlequinServerData):boolean {
        return (this.nextMode === "WILD_RESPIN" || this.nextMode === "WILD_RESPIN_FS");
    }

    private readonly _accumulatedRoundWin:string;
    public get accumulatedRoundWin():string {
        return this._accumulatedRoundWin;
    }

    constructor(rawData:IHarlequinGameData, dataParser:HarlequinServerDataParser) {
        super(rawData, dataParser);

        this._doReelNudge = dataParser.parseDoReelNudge(rawData);
        this._extraSymbolsOnTop = dataParser.parseExtraSymbolsOnTop(rawData);

        this._wildOverlayReels = rawData.wildOverlayReels;
        this._wildOverlayReelsBefore = rawData.wildOverlaysBefore;

        this._wildMultipliers = rawData.wildMultipliers;
        this._wildMultipliersBefore = rawData.wildMultipliersBefore;
        //this._wildMultipliersAfter = rawData.wildMultipliersBefore;

        this._scattersFSCollectedAfter = rawData.scattersFSCollectedAfter;
        this._scattersFSCollectedBefore = rawData.scattersFSCollectedBefore;

        this._scattersCollectedFSAfter = rawData.scattersCollectedFSAfter;
        this._scattersCollectedFSBefore = rawData.scattersCollectedFSBefore;
        this._extraScatterThisFSSpin = rawData.extraScatterThisFSSpin;

        this._wildDrop = rawData.wildDrop;
        this._scattersCollected = rawData.scattersCollected;

        this._scatterCollected = rawData.scatterCollected;

        this._freespinPlayed = rawData.freespinPlayed;
        this._totalSpinWinnings = rawData.totalSpinWinnings;

        this._betLineWins = rawData.betLineWins;

        this._totalRespinWin = rawData.totalRespinWin;

        this._extraSpinsAwardedThisSpin = rawData.extraSpinsAwardedThisSpin;

        this._firstSpinWildDrop = rawData.firstSpinWildDrop;

        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }
}